
<div class="component-container" data-i18n-skip>

  <div class="content-container">
    <p class="header-text">{{ forceMode ? ('Complete Your Profile' | translate) : ('Personal Settings' | translate) }}</p>
    <p *ngIf="forceMode" class="force-mode-text">{{ 'Please fill in your information to get started.' | translate }}</p>


    <user-settings-inputs #userSettingsInputs class="component-content"
      [userSettingsComplete]="tempUserSettingsComplete"
      [validationErrors]="validationErrors"
      [showEmail]="true"
    >

    </user-settings-inputs>

    <div class="push-container">
      <!--User Push Notification Setting-->
      <mat-checkbox class="component-content welcome-input"
        [(ngModel)]="tempUserSettingsComplete?.userPushSettings.enabled"
      >
        {{ 'Enable Push Notifications' | translate }}
      </mat-checkbox>
  
      <div class="nested-push-container" *ngIf="tempUserSettingsComplete?.userPushSettings.enabled">
        <mat-checkbox class="component-content welcome-input"
          [(ngModel)]="tempUserSettingsComplete?.userPushSettings.componentValueUpdates"
        >
          {{ 'Support Conversations' | translate }}
        </mat-checkbox>
  
      </div>
    </div>

    <button class="max-btn mat-primary-lighter" (click)="updateUserInformation()" mat-button mat-raised-button color="primary" [disabled]="forceMode && !isProfileComplete()">{{ 'Save User Settings' | translate }}</button>

    <button *ngIf="!forceMode" class="max-btn delete-account-btn" (click)="navigateToDeleteAccount()" mat-button mat-raised-button color="warn">{{ 'Delete Account' | translate }}</button>

  </div>
</div>